import React from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions, DateTime, TextArea, RequiredValidator, EventTriggers, ItemisationAdjustment, ExternalPayment } from '../../Components/Form';
import { useCustomer } from '../../Data/Customers';
import { dateTimeToString } from '../../Services/helpers';
import { eventTriggers } from '../../Data/Misc';

const MarkAsDone = ({job, onClose, then}) => {
    return <Modal title="Mark job as done" isOpen={!!job} setIsOpen={onClose} dismissible>
        {job && <Inner job={job} then={then} />}
    </Modal>
}

const Inner = ({job, then}) => {
    const {markJobAsDone} = useCustomer(job?.customerId);

    const doSubmit = (data) => {
        return markJobAsDone(job.id, {
            addExternalPayment: data?.externalPayment?.addExternalPayment ?? false,
            paymentMethod: data?.externalPayment?.paymentMethod ?? null,
            amount: data?.externalPayment?.amount ?? null,
            ...data,
        });
    }

    const data = {
        doneOn: dateTimeToString(new Date(), 'T'),
        externalPayment: {
            amount: job?.cost
        },
        itemisationAdjustment: job.itemisationAdjustment
    }

    return <Form data={data}
            onSubmit={doSubmit}
            afterSubmit={then}
            closeModalOnSubmit
        >
        <DateTime name="doneOn" label="Done at" validators={[RequiredValidator]} defaultNow />
        <TextArea name="notes" label="Notes" />
        <ExternalPayment name="externalPayment" label="Add external payment" />
        <ItemisationAdjustment originalCost={job.cost} />

        <EventTriggers triggers={[
            eventTriggers.SEND_NOTIFICATIONS, eventTriggers.INVOICE, eventTriggers.CHARGE, eventTriggers.LOYALTY_CARDS
        ]} />
        <Actions submit={{label: 'Done'}} cancel />
    </Form>
}

export default MarkAsDone;
